import React, { useState } from 'react';
import axios from 'axios';

const UploadReport: React.FC = () => {
    const [error, setError] = useState<string | null>(null);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setError(null);
        const file = event.target.files?.[0];
        if (!file) return;

        if (!file.name.endsWith('.csv')) {
            setError('Only CSV files are allowed.');
            return;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const text = e.target?.result as string;
                const lines = text.trim().split('\n');
                const headers = lines[0].split(',').map((h) => h.trim());

                const requiredHeaders = ['Id', 'Subject', 'email', 'Date', 'Status', 'Open', 'Click', 'tag'];
                for (let h of requiredHeaders) {
                    if (!headers.includes(h)) {
                        setError(`Missing header: ${h}`);
                        return;
                    }
                }

                const messages: any[] = [];

                for (let i = 1; i < lines.length; i++) {
                    const cells = lines[i].split(',').map((cell) => cell.trim());

                    // ✅ Add this validation for correct number of columns
                    if (cells.length !== headers.length) {
                        setError(`Row ${i + 1} has incorrect number of columns. Expected ${headers.length}, found ${cells.length}.`);
                        return;
                    }

                    const row: any = Object.fromEntries(headers.map((h, idx) => [h, cells[idx]]));
                    const rowNumber = i + 1;

                    if (!row['email'] || !row['Subject']) {
                        setError(`Row ${rowNumber}: Missing 'email' or 'Subject'. Upload aborted.`);
                        return;
                    }

                    messages.push({
                        to_email: row['email'],
                        last_event_time: formatToISO(row['Date']),
                        subject: row['Subject'],
                        status: row['Status'] || '',
                        from_email: 'team@moengage.com',
                        msg_id: `msg${row['Id']}`,
                        opens_count: parseInt(row['Open'] || '0'),
                        clicks_count: parseInt(row['Click'] || '0'),
                    });
                }

                console.log('Uploading messages:', messages); // ✅ Debug log

                const response = await axios.post(
                    `${process.env.REACT_APP_BROADCAST_SERVER}/referral/upload-moengage`,
                    { messages },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );
                alert(response.data.message);
            } catch (err: any) {
                console.error(err);
                setError(err.message || 'File processing error.');
            }
        };

        reader.readAsText(file);
    };

    const formatToISO = (dateStr: string): string => {
        // Expected: DD-MM-YYYY HH:mm
        const [d, m, yAndTime] = dateStr.split('-');
        const [y, time] = yAndTime.split(' ');
        return `${y}-${m}-${d}T${time}:00Z`;
    };

    return (
        <div className="max-1140 mx-auto py-5 flex-1">
            <h2 className="font-20 mb-2">Upload Moengage Data</h2>
            <div className="alert alert-info">
                <h5>Please Note:</h5>
                <ul>
                    <li>The file must be in CSV format (.csv).</li>
                    <li>
                        <strong>To Email</strong> and <strong>Moengage ID</strong> and <strong>other</strong> columns should not be
                        blank.
                    </li>
                    <li>
                        <strong>Email </strong> must be valid.
                    </li>
                </ul>
                <div className='d-flex align-items-center'>
                    <a href="https://s3.ap-south-1.amazonaws.com/media.univariety.dev/sample_email_data.csv" className="btn btn-green " download="">
                        <span className='d-flex align-items-center'><i className="bi bi-cloud-arrow-down-fill font-20 me-2"></i> Download Sample CSV File</span>
                    </a>
                </div>
            </div>
            <label className="form-label m-0 mb-1 font-16 font-500 w-100" htmlFor="cloud-computing">
                 Attachment (CSV only)
            </label>
            <div className="upload_section mb-2">
                <input type="file" id="cloud-computing" className="cursor-pointer" accept=".csv" onChange={handleFileChange} />
                <div className="row g-2 align-items-center justify-content-center">
                    <div className="col-sm d-flex align-items-center justify-content-center">
                        <div className="cloud-wrap px-3 px-sm-5 mx-auto">
                            <div className="cloud-img">
                                <img src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/cloud-computing.svg" alt="cloud" />
                            </div>
                            <div className="cloud-text">
                                <a href="#" onClick={(e) => e.preventDefault()} className="text-sky-blue text-decoration-none">
                                    Browse
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {error && <div className="text-danger mt-3">{error}</div>}
        </div>
    );
};

export default UploadReport;
